export function newVoucherObject() {
  this.voucherValue = null
  this.voucherPurchaserName = "Ms Sissi Admin"
  this.voucherPurcherEmail = "office@ms-sissi.at"
  this.voucherPurcherAddress = "Ms Sissi Office"
}